import { useState } from 'react';
import { ReactPortalElementId } from 'core/layouts';
import { PAGE_VARIATIONS, TAB_OPTIONS } from '../../constants';
import { Tabs } from './Tabs';
import { SegmentationResultsWrapper, ToolbarWrapper } from './SegmentationResults.styles';
import { UsersTable } from './usersTable/UsersTable';
import { ListReferencesTable } from './referencesInsights/ListReferencesTable';
import { BehaviorInsights } from './behaviorInsights/BehaviorInsights';
import { Demographics } from './demographics/Demographics';
import { useListDetailsContext } from '../../contexts/listDetails';
import { InsightsBoundaryContextProvider } from '../../contexts/insightsBoundary';
import { UsersTableColumnsContextProvider } from '../../contexts/usersTableColumns';

/* Note: User's Table vs Audience Insights (Behavior, Demographics, & References)
 * We specifically do insights on the saved lists only. Additionally, we cache the results for
 * an hour so that query changes won't be reflected immediately.
 * Conversely, The user's table will reflect changes based on a modified query (after refreshing
 * results)
 * Support: https://support.iterable.com/hc/en-us/articles/7922758001940-Using-Audience-Insights-to-Understand-Your-Users
 */

export const testIds = {
  segmentationResultsWrapper: 'segmentationResults-wrapper',
  toolbarWrapper: 'segmentationResults-toolbarWrapper',
};

export const SegmentationResults = () => {
  const [selectedTab, setSelectedTab] = useState(TAB_OPTIONS.USERS);
  const { pageVariation } = useListDetailsContext();
  const segmentationResultsContent = (
    <UsersTableColumnsContextProvider>
      <SegmentationResultsWrapper data-test={testIds.segmentationResultsWrapper}>
        <ToolbarWrapper data-test={testIds.toolbarWrapper}>
          <Tabs selectedTab={selectedTab} onTabChange={setSelectedTab} />
          <div id={ReactPortalElementId.sementationInsightsToolbarActions} />
        </ToolbarWrapper>
        {selectedTab === TAB_OPTIONS.USERS && <UsersTable />}
        {selectedTab === TAB_OPTIONS.BEHAVIORS && <BehaviorInsights />}
        {selectedTab === TAB_OPTIONS.DEMOGRAPHICS && <Demographics />}
        {selectedTab === TAB_OPTIONS.REFERENCES && <ListReferencesTable />}
      </SegmentationResultsWrapper>
    </UsersTableColumnsContextProvider>
  );

  // Only apply insights providers when viewing existing list
  if (pageVariation === PAGE_VARIATIONS.SEGMENTATION) {
    return segmentationResultsContent;
  } else {
    return (
      <InsightsBoundaryContextProvider>
        {segmentationResultsContent}
      </InsightsBoundaryContextProvider>
    );
  }
};
